import React, { Fragment, useEffect, useRef, useState } from "react";
import useSort from '../../../hooks/useSorting';
import Cs from "../../../services/CommonService";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import { LinkDeleteIcon } from "../../Common/ImageIcons";
import PaginationSM from '../../Common/PaginationSM';
import SortDirection from '../../Common/SortDirection';
import { Spinner } from "../../Common/Spinner";
import { Table, TBody, TD, TH, THead, TR } from "../../Common/TableView";
import DslDsMappingService from "./DslDsMappingService";
import useModal from "../../../hooks/useModal";
import CommentsModal from "../../Modals/CommentsModal";
import { LinkFontAwesomeIcon } from "../../Common/ImageIcons";
import FormTemplateService from "../../../services/FormTemplateService";
import {OptionsObjList} from '../../Common/FormInput';
import DataSourceService from "../../../services/DataSourceService";
import GenericModal from "../../Modals/GenericModal";
import DslDsMappingForm from "./DslDsMappingForm";
import ConfirmMenu from "../../Modals/ConfirmMenu";
import DynamicTable from '../../Common/DynamicTable';
import { NavIcon } from '../../Common/MenuItem';

const DslDsMappingListTable = ({dsl}) => {
  let { current: scope } = useRef({ requestParams: {} });
  const { currentUser } = useCurrentUserHook();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [pagemeta, setPagemeta] = useState({});

  const {isOpen: isDeleteOpen, toggleModal: toggleDeleteModal } = useModal();
  const {isOpen:isFormOpen, toggleModal:toggleFormModal} = useModal();

  useEffect(() => { 
    setParams(1);
    getAll();
  }, [])

  const setParams = (page) => {
    scope.requestParams = {
      'page': page,
      'paginate': 1,
      'per_page': 15,
      'sort_column': scope.requestParams.sort_column || 'updated_at',
      'sort_direction': scope.requestParams.sort_direction || 'desc',
    }
  }

  const onPageChage = (page) => {
    setParams(page);
    getAll();
  }

  const getAll = async () => {
    setLoading(true);
    const { status, data } = await DslDsMappingService.getAll(scope.requestParams);
    if (status == 200) {
      setList(data.dsl_ds_mappings);
      setPagemeta(data.meta);
      setLoading(false);
    }
  }

  const deleteDslDsMapping = async () => {
    setLoading(true);
    const { status } = await DslDsMappingService.delete(scope.selectedDslDsMapping.id);
    if (status === 204) {
      setList(list.filter(i => i.id !== scope.selectedDslDsMapping.id));
    }
  
    setLoading(false);
    toggleDeleteModal();
  };
  
  const onDelete = (dslDsMapping) => {
    scope.selectedDslDsMapping = dslDsMapping;
    toggleDeleteModal();
  }
  
  const openDslDsMappingFormModal = (dslDsMapping) => {
    scope.dslDsMappingFormProps = {
      'onSubmit':onSubmit,
      'dsl':dsl
    }
    toggleFormModal();
  }

  const onSubmit = (dslDsMapping) =>{
    onPageChage(1);
  }

  const SortDirIco = ({ column }) => {
    return (
      <SortDirection sortColumn={scope.requestParams.sort_column}
      column={column} reverse={scope.requestParams.reverse} />
    )
  }

  const { sort } = useSort(scope.requestParams, getAll);

  const tableData = list.map((o, k) =>
    <Fragment key={k}>
      <tr>
        <td className="text-center">
          {o.id}
        </td>
        <td className="text-center">
          {o.s_dsl_label}
        </td>
        <td className="text-center">
          {o.t_ds_title}
        </td>
        <td className="flex aligncenter">
          <div className="flex coldir aligncenter rgap-5 pointer">
            <LinkDeleteIcon id="delete_dslDsMapping" 
              tooltip="Delete dslDsMapping" 
              onSelect={() => onDelete(o)} />
          </div>  
        </td>
      </tr>
    </Fragment>
  )

  return (
      <div id="ct">
        <div className="app-content">
          <div className="app-header flex justspacebetween m-t-15">
            <div className="flex coldir">
              <div className="app-title m-r-20">Dsl Ds Mappings</div>
              <div className="font-15 m-t-2">
                Total - {pagemeta.total} | Page - {pagemeta?.current_page}/{pagemeta?.last_page}
              </div>
            </div>
            <div className="flex aligncenter">
              <NavIcon id="new_action" dataTip="Create New Mapping" 
                className="bg-highlight round-btn m-r-5" 
                icon="fas fa-plus"
                onSelect={()=>openDslDsMappingFormModal()}/>
            </div>
          </div>

          {loading ? <Spinner /> : null}

          <div className="app-content-section m-t-30 table-fix-head">
            <Table className="shadow-small">
              <THead>
                <TR>
                  <TH className="p-2 bold-400 text-center miw-95" onClick={() => sort('id')}>
                    ID
                    <SortDirIco column="id" />
                  </TH>
                  <TH className="p-2 bold-400 text-center miw-95" onClick={() => sort('label')}>
                    DataSource List
                    <SortDirIco column="label" />
                  </TH>
                  <TH className="p-2 bold-400 text-center miw-95" onClick={() => sort('label')}>
                    DataSource
                    <SortDirIco column="label" />
                  </TH>
                  <TH>
                    Action
                  </TH>
                </TR>
              </THead>
              <TBody>
                {tableData}
              </TBody>
            </Table>
          </div>

          <PaginationSM
            className="pagination-bar"
            currentPage={parseInt(pagemeta.current_page)}
            totalItems={pagemeta.total}
            itemsPerPage={pagemeta.per_page}
            onPageChange={onPageChage}
            siblingCount={2} />
        </div>

        {isFormOpen && 
          <GenericModal 
            component={DslDsMappingForm}
            isOpen={isFormOpen} 
            toggleModal={toggleFormModal} 
            {...scope.dslDsMappingFormProps}/>
        }

        <ConfirmMenu isOpen={isDeleteOpen} 
          toggleModal={toggleDeleteModal} 
          success={() => deleteDslDsMapping(scope.selectedDslDsMapping)}/>

      </div>
  )

}

export default DslDsMappingListTable;